import {Layout} from '../../../layout'
import {PageHeaderTitle} from './title'
import './styles.less'

export const FullScreenPageHeader = ({className, left, right, height, ...rest}) => {
	return (
		<Layout relative borderBottom width="full" horizontal="spaceBetween" className={className} padding={height === 'small' ? 4 : 16}>
			<Layout className="left-page-header">{left}</Layout>
			<PageHeaderTitle {...rest} />
			<Layout className="right-page-header">{right}</Layout>
		</Layout>
	)
}
